import React, { Component } from 'react';
import radium from 'radium';

class OptionItem extends Component {
  getOptionGroupName = lesson => `option-${lesson.items[0].id}`;

  getOptionUID = (lesson, option) => `option-${option.id}-${lesson.items[0].id}-${lesson.id}`;

  render() {
    const { lesson, option } = this.props;

    return (
      <div className="OptionItemContainer quiz-answer">
        <input
          type="radio"
          data-quiz-answer-input="true"
          className="quiz-answer__input"
          id={this.getOptionUID(lesson, option)}
          name={this.getOptionGroupName(lesson, option)}
        />
        <label className="quiz-answer__label" htmlFor={this.getOptionUID(lesson, option)}>
          <span className="quiz-answer__radio brand--afterBackground">
            <i className="icon icon-tick" />
            <i className="icon icon-close-media-panel" />
          </span>
          <span className="brand--head brand--linkColor">{option.title}</span>
        </label>
      </div>
    );
  }
}

export default radium(OptionItem);
